import type { HTMLAttributes } from "react"

import { cn } from "@/lib/utils"

export default function InputError({
  messages,
  className = "",
  ...props
}: HTMLAttributes<HTMLParagraphElement> & { messages?: string | string[] }) {
  const list = messages
    ? Array.isArray(messages)
      ? messages
      : [messages]
    : null
  return list ? (
    <p
      {...props}
      className={cn("text-sm text-red-600 dark:text-red-400", className)}
    >
      {list.join(", ")}
    </p>
  ) : null
}
